import moment from 'moment' // 时间格式化

export default {
  formatDateTime: function (value, format) {
    let str = format || 'YYYY-MM-DD HH-mm'
    if (value) {
      return moment(value).format(str)
    }
    return value
  }
}



// WEBPACK FOOTER //
// ./src/utils/tools/filter.js